import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Test } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddTestState {
  title: string;
  description: string;
  tests: Test[];
}

// Define the initial state using that type
const initialState: AddTestState = {
  description: "",
  title: "",
  tests: [],
};

export const addTestSlice = createSlice({
  name: "addTest",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
    },
    setTests: (state, action: PayloadAction<Test[]>) => {
      state.tests = action.payload;
    },
  },
});

export const { setTitle, setDescription, setTests } = addTestSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAddTestData = (state: RootState) => state.addTest;
export default addTestSlice.reducer;
